import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { Parameter } from '../../models/parameter.model';
import { Api } from '../util/api';

@Injectable()
export class SettingsService {
  private endpoint = 'configurations';

  constructor(private api: Api) {
  }

  public getMonitoringThreshold(): Observable<Parameter> {
    return this.api.get(this.endpoint).map(
      (configurations: Parameter[]) => configurations.find(configuration => configuration.name === 'surveillanceParameter')
    );
  }

  public updateMonitoringThreshold(monitoringThreshold: Parameter): Observable<any> {
    return this.api.put(`${this.endpoint}/${monitoringThreshold.id}`, monitoringThreshold).map(
      (monitoringThreshold) => this.api.handleSuccess(monitoringThreshold)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/settings.service.ts